import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'dmmp-link-icon',
  templateUrl: './link-icon.component.html'
})
export class LinkIconComponent implements OnInit {

  @Input() data
  @Input() identifier
  @Input() defaultClass
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()

  constructor() { }

  ngOnInit(): void {
  }

  ancla(event) {
    this.anchorCustom.emit(event)
  }

}
